import request from '@/utils/request'

// 查询小微企业-文明诚信管理列表
export function listWmcxgl(query) {
  return request({
    url: '/web/xwqy/wmcxgl/list',
    method: 'get',
    params: query
  })
}

// 查询小微企业-文明诚信管理详细
export function getWmcxgl(recid) {
  return request({
    url: '/web/xwqy/wmcxgl/' + recid,
    method: 'get'
  })
}
